import React, { useState, Fragment } from "react";

import LineItem from "./LineItem";
import RowInfo from "../RowInfo";
import RecursiveItens from "./RecursiveItens";

import ResetPasswordModal from "../ResetPasswordModal";
import ResetPasswordEmailModal from "../ResetPasswordEmailModal";

export default function AccordionItens({
  model,
  item,
  idUser,
  endPoint,
  indKey,
  idEnrollment,
  nodeCode,
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [openReset, setOpenReset] = useState(false);
  const [controlModalAcitionOpen, setControlModalAcitionOpen] = useState(false);


  function toggle(e) {
    isExpanded ? setIsExpanded(false) : setIsExpanded(true);
    e.stopPropagation();
  }

  return (
    <>
      <div className={`AccordionItens  ${isExpanded && "border-open"}`}>
        <div
          className={`${model === "userTeam" ? "titleAccordion" : "titleAccordionRes"}`}
          onClick={(e) => {
            toggle(e);
          }}
        >
          {model === "userTeam" ? (
            <>
              <RowInfo
                isExpanded={isExpanded}
                item={item}
                onResetPassword={() => setOpenReset(true)}
                onResetEmailPassword={() => setControlModalAcitionOpen(true)}
              />
            </>
          ) : (
            <LineItem item={item} idUser={idUser} arcodeonStatus={isExpanded} />
          )}
        </div>
        {isExpanded && (
          <div
            className={`collapseAccordion ${model === "userTeam" && "collapseAccordionStudents"}`}
          >
            <RecursiveItens
              endPoint={endPoint}
              idUser={idUser}
              indice={indKey}
              idEnrollment={idEnrollment}
              nodeCode={nodeCode}
              open={isExpanded}
            />
          </div>
        )}

        {openReset && (
          <ResetPasswordModal
            open={openReset}
            onClose={() => setOpenReset(false)}
            idUser={item.idUser}
            userName={item.name}
          />
        )}

        <ResetPasswordEmailModal
          controlModalAcitionOpen={controlModalAcitionOpen}
          setControlModalAcitionOpen={setControlModalAcitionOpen}
          item={item}
        />
      </div>
    </>
  );
}
